
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { loadProviders } from "@/utils/emailUtils";
import ProviderTabs from "./providers/ProviderTabs";

interface EmailProviderSetupProps {
  onProviderUpdated: () => void;
  activeTab?: string;
  showHeader?: boolean;
}

const EmailProviderSetup = ({ 
  onProviderUpdated, 
  activeTab = "email",
  showHeader = true 
}: EmailProviderSetupProps) => {
  const providers = loadProviders();
  
  return (
    <Card>
      {showHeader && (
        <CardHeader>
          <CardTitle>Email Provider Setup</CardTitle>
          <CardDescription>
            Connect your email provider to send emails directly from this platform
          </CardDescription>
        </CardHeader>
      )}
      <CardContent>
        <ProviderTabs 
          providers={providers} 
          onProviderUpdated={onProviderUpdated} 
          defaultTab={activeTab}
        />
      </CardContent>
      {showHeader && (
        <CardFooter className="flex justify-between">
          <p className="text-sm text-muted-foreground">
            Email integrations are coming soon with full functionality
          </p>
        </CardFooter>
      )}
    </Card>
  );
};

export default EmailProviderSetup;
